<div class="row form">
  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <div class="page-title-box form__head">
      <div class="row align-items-center">
        <div class="col-sm-6 col-6">
          <a class="page-title form__head__title" (click)="cancel()">
            <i class="fas fa-arrow-left m-r-5"></i>{{txtSubmenu}} producto
          </a>
        </div>
        <div class="col-sm-6 col-6 form__head__boxBtn">
          <p class="m-b-0 m-t-5">Campos requeridos (<span class="required-top">*</span>)</p>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-12">
    <div class="card m-b-30">
      <div class="card-body">
        <form validate [formGroup]="item" (ngSubmit)="onSubmit()">
          <div class="row">
            <div class="col-lg-12">
              <div class="row">
                <div class="form-group col-lg-3">
                  <label>Tipo producto<span class="required"></span></label>
                  <select class="form-control" disabled="true">
                    <option *ngFor="let item of type_products" [value]="item.id">{{ item.description }}</option>
                  </select>
                </div>
                <div class="form-group col-lg-3">
                  <label>
                    <span data-toggle="tooltip" data-placement="right" data-original-title="Código de barras"><i
                        class="fas fa-info-circle f-s-14"></i></span>
                    Código <span class="badge badge-info m-l-5" *ngIf="!isEdit">Se va asignar uno</span></label>
                  <input type="text" id="product_code" maxlength="25" class="form-control text-uppercase"
                    formControlName="code">
                </div>
                <div class="form-group col-lg-6">
                  <label>Nombre del producto<span class="required"></span></label>
                  <input type="text" id="product_description" required class="form-control" autofocus
                    formControlName="description">
                </div>
              </div>
            </div>
            <div class="col-lg-9">
              <div class="row">
                <div class="form-group col-lg-4">
                  <label>Marca
                    <span class="badge badge-success m-l-10 ng-binding" *ngIf="brands.length == 0">0 registros</span>
                    <!-- <button type="button" ng-click="addBrand(true)" *ngIf="brands.length > 0"
                      class="btn btn-outline-success btn-extends float-right"><i class="fa fa-plus m-r-5"></i>Nuevo
                    </button> -->
                  </label>
                  <div *ngIf="brands.length == 0">
                    <!-- <button type="button" class="btn btn-outline-success"
                      ng-disabled="typeProductSelected.id==is_service.id" ng-click="addBrand(true)"><i
                        class="fas fa-arrow-right m-r-5"></i>Agregar marca
                    </button> -->
                    <span>No se encontraron registros</span>
                  </div>
                  <ng-container *ngIf="brands.length > 0">
                    <ng-autocomplete #searchInputBrand [class]="'search-small search-brand'" [data]="brands"
                      [initialValue]="initialBrand" [searchKeyword]="'description'" placeholder="Seleccionar marca"
                      (selected)='selectSearchBrand($event)' (inputCleared)='clearedSearchBrand()'
                      [itemTemplate]="itemTemplate" [notFoundTemplate]="notFoundTemplate">
                    </ng-autocomplete>
                    <ng-template #itemTemplate let-item>
                      <a style="padding: 8px 15px;" class="f-s-12 p-10" [innerHTML]="item.description"></a>
                    </ng-template>
                    <ng-template #notFoundTemplate let-notFound>
                      <p class="p-t-5 m-b-5 bold">No se encontraron registros</p>
                    </ng-template>
                  </ng-container>
                </div>
                <div class="form-group col-lg-4">
                  <label>Categorias
                    <span class="badge badge-success m-l-10 ng-binding" *ngIf="categories.length == 0">0
                      registros</span>
                    <!-- <button type="button" *ngIf="categories.length > 0"
                      class="btn btn-outline-success btn-extends float-right"><i class="fa fa-plus m-r-5"></i>Nuevo
                    </button> -->
                  </label>
                  <div *ngIf="categories.length == 0">
                    <!-- <button type="button" class="btn btn-outline-success"><i
                        class="fas fa-arrow-right m-r-5"></i>Agregar categoría
                    </button> -->
                    <span>No se encontraron registros</span>
                  </div>
                  <ng-container *ngIf="categories.length > 0">
                    <ng-autocomplete #searchInputCategory [class]="'search-small search-category'" [data]="categories"
                      [initialValue]="initialCategory" [searchKeyword]="'description'"
                      placeholder="Seleccionar categoría" (selected)='selectSearchCategory($event)'
                      (inputCleared)='clearedSearchCategory()' [itemTemplate]="itemTemplate"
                      [notFoundTemplate]="notFoundTemplate">
                    </ng-autocomplete>
                    <ng-template #itemTemplate let-item>
                      <a style="padding: 8px 15px;" class="f-s-12 p-10" [innerHTML]="item.description"></a>
                    </ng-template>
                    <ng-template #notFoundTemplate let-notFound>
                      <p class="p-t-5 m-b-5 bold">No se encontraron registros</p>
                    </ng-template>
                  </ng-container>
                </div>
                <!-- <div class="form-group col-lg-4">
                  <label>Líneas
                    <span class="badge badge-success m-l-10 ng-binding" *ngIf="lines.length == 0">0 registros</span>
                    <button type="button" *ngIf="lines.length > 0"
                      class="btn btn-outline-success btn-extends float-right"><i class="fa fa-plus m-r-5"></i>Nuevo
                    </button>
                  </label>
                  <div *ngIf="lines.length == 0">
                    <button type="button" class="btn btn-outline-success"><i
                        class="fas fa-arrow-right m-r-5"></i>Agregar línea
                    </button>
                  </div>
                  <ng-container *ngIf="lines.length > 0">
                    <ng-autocomplete #searchInputLine [class]="'search-small search-line'" [data]="lines"
                      [initialValue]="initialLine" [searchKeyword]="'description'" placeholder="Seleccionar línea"
                      (selected)='selectSearchLine($event)' (inputCleared)='clearedSearchLine()'
                      [itemTemplate]="itemTemplate" [notFoundTemplate]="notFoundTemplate">
                    </ng-autocomplete>
                    <ng-template #itemTemplate let-item>
                      <a style="padding: 8px 15px;" class="f-s-12 p-10" [innerHTML]="item.description"></a>
                    </ng-template>
                    <ng-template #notFoundTemplate let-notFound>
                      <p class="p-t-5 m-b-5 bold">No se encontraron registros</p>
                    </ng-template>
                  </ng-container>
                </div> -->
                <div class="form-group col-lg-4">
                  <label>Unidad medida</label>
                  <select class="form-control" id="unitSelected" (change)="changeUnitSelected()"
                    [(ngModel)]="unitSelected" [ngModelOptions]="{standalone: true}">
                    <option *ngFor="let item of units" [value]="item.id">{{ item.description }}</option>
                  </select>
                </div>
                <div class="form-group col-lg-4">
                  <div class="custom-control custom-checkbox m-t-5">
                    <input type="checkbox" class="custom-control-input" id="is_show" name="is_show"
                      formControlName="is_show">
                    <label class="custom-control-label p-t-3" for="is_show">Es visible</label>
                  </div>
                </div>
                <div class="form-group col-lg-4">
                  <div class="custom-control custom-checkbox m-t-5">
                    <input type="checkbox" class="custom-control-input" id="is_favorite" name="is_favorite"
                      formControlName="is_favorite">
                    <label class="custom-control-label p-t-3" for="is_favorite">Es favorito en
                      venta</label>
                  </div>
                </div>
                <div class="form-group col-lg-4">
                  <div class="custom-control custom-checkbox m-t-5">
                    <input type="checkbox" class="custom-control-input"
                      ng-disabled="typeProductSelected.id==is_service.id" id="is_control_stock" name="is_control_stock"
                      formControlName="is_control_stock">
                    <label class="custom-control-label p-t-3" for="is_control_stock">¿Control de
                      stock?</label>
                  </div>
                </div>
                <div class="form-group col-lg-6">
                  <div class="custom-control custom-checkbox m-t-5">
                    <input type="checkbox" class="custom-control-input" id="is_control_expiration"
                      name="is_control_expiration" formControlName="is_control_expiration">
                    <label class="custom-control-label p-t-3" for="is_control_expiration">¿Control fecha
                      vencimiento?</label>
                  </div>
                </div>
                <div class="form-group col-lg-2"></div>
                <!-- <div class="form-group col-lg-4">
                  <div class="custom-control custom-checkbox m-t-5">
                    <input type="checkbox" class="custom-control-input" name="is_grouped" formControlName="is_grouped">
                    <label class="custom-control-label p-t-3" for="is_grouped">¿Es producto agrupado?</label>
                  </div>
                </div> -->

                <div class="col-lg-12 m-t-10">
                  <p class="form__group__title"> <i class="fa fa-money-bill m-r-3"></i>Asignar precio al producto</p>
                  <div class="row">
                    <div class="form-group col-lg-6">
                      <label>Seleccionar tipo precio<span class="required"></span></label>
                      <select formControlName="typeprice_id" class="form-control" (change)="changeTypePrice()">
                        <option *ngFor="let item of typeprices" [disabled]="isEdit" [value]="item.id">
                          {{ item.description }}</option>
                      </select>
                    </div>
                    <ng-container *ngIf="item.value.typeprice_id == typeprice_general">
                      <div class="form-group col-lg-3">
                        <label>
                          <span class="m-r-5" data-toggle="tooltip" data-placement="right"
                            data-original-title="Precio de venta general"><i
                              class="fas fa-info-circle f-s-14"></i></span>
                          <span class="text-primary price-general bold">PV. GENERAL</span><span class="required"></span>
                        </label>
                        <div class="input-group">
                          <span class="input-group-prepend"><span
                              class="input-group-text">{{toolsService.momeySol()}}</span></span>
                          <input type="text" class="form-control bold text-primary" numeric decimals="2"
                            onclick="click_input(this)" [(ngModel)]="price_general.price_sale"
                            [ngModelOptions]="{standalone: true}">
                        </div>
                      </div>
                      <div class="form-group col-lg-9" style="display: none;">
                        <p class="bold">Otros precios referenciales</p>
                        <div class="row">
                          <div class="form-group col-lg-4">
                            <label><span data-toggle="tooltip" data-placement="right"
                                data-original-title="Precio de venta mínimo" title=""><i
                                  class="fas fa-info-circle f-s-14"></i></span>
                              PV. mínimo
                            </label>
                            <div class="input-group">
                              <span class="input-group-prepend"><span class="input-group-text">S/</span></span>
                              <input type="text" class="form-control bold" numeric decimals="2"
                                onclick="click_input(this)" [(ngModel)]="price_general.price_min"
                                [ngModelOptions]="{standalone: true}">
                            </div>
                          </div>
                          <div class="form-group col-lg-4">
                            <label><span data-toggle="tooltip" data-placement="right"
                                data-original-title="Precio crédito" title=""><i
                                  class="fas fa-info-circle f-s-14"></i></span>
                              PV. crédito
                            </label>
                            <div class="input-group">
                              <span class="input-group-prepend"><span class="input-group-text">S/</span></span>
                              <input type="text" class="form-control bold" onclick="click_input(this)"
                                [(ngModel)]="price_general.price_credit" [ngModelOptions]="{standalone: true}">
                            </div>
                          </div>
                          <div class="form-group col-lg-4">
                            <label><span data-toggle="tooltip" data-placement="right"
                                data-original-title="Precio mayorista"><i class="fas fa-info-circle f-s-14"></i></span>
                              PV. mayorista
                            </label>
                            <div class="input-group">
                              <span class="input-group-prepend"><span class="input-group-text">S/</span></span>
                              <input type="text" class="form-control bold" onclick="click_input(this)"
                                [(ngModel)]="price_general.price_wholesaler" [ngModelOptions]="{standalone: true}">
                            </div>
                          </div>
                        </div>
                      </div>
                    </ng-container>

                    <ng-container *ngIf="item.value.typeprice_id == typeprice_unit">
                      <div class="form-group col-lg-6">
                        <div class="row m-t-25">
                          <div class="col-lg-5">
                            <label class="m-t-0 text-center w-100">Equivalencias
                              <span class="f-s-11">({{unitSelectedValue.description}})</span>
                            </label>
                          </div>
                          <div class="col-lg-7">
                            <div class="input-group">
                              <select class="form-control" id="unitChildSelected" [(ngModel)]="unitChildSelected"
                                [ngModelOptions]="{standalone: true}">
                                <option *ngFor="let item of units_childs" [value]="item.id">{{ item.description }}
                                </option>
                              </select>
                              <div class="input-group-append">
                                <a class="btn btn-success btn-sm text-white pointer f-s-12"
                                  (click)="addUnitPrice()">Agregar</a>
                              </div>
                            </div>
                          </div>
                          <!-- <div class="col-lg-2 p-0">
                            <a class="btn btn-success text-white pointer" (click)="addUnitPrice()">Agregar</a>
                          </div> -->
                        </div>
                      </div>
                      <div class="form-group col-lg-12">
                        <div class="table-responsive">
                          <table class="table mb-0 table-sm">
                            <thead class="thead-default">
                              <tr>
                                <th>#</th>
                                <th class="w-30">Nombre</th>
                                <th>Prefix</th>
                                <th class="w-20 text-center">Equivalencia</th>
                                <th class="w-20 text-center">Precio</th>
                                <th class="text-center"></th>
                              </tr>
                            </thead>
                            <tbody>
                              <ng-container *ngIf="unitprices.length == 0">
                                <td colspan="3"><span>No se encontraron registros</span></td>
                              </ng-container>
                              <ng-container *ngIf="unitprices.length > 0">
                                <tr *ngFor="let item of unitprices; let index_ = index">
                                  <td scope="row">-</td>
                                  <td class="w-30">
                                    {{item.description}}
                                    <span *ngIf="item.is_principal" class="badge badge-info m-l-5">Principal</span>
                                  </td>
                                  <td>{{item.prefix}}</td>
                                  <td class="w-20">
                                    <input type="text" id="equivalence{{index_}}" value="{{item.equivalence}}"
                                      (keyup)="changeUnitEquivalence($event.target, index_)" numeric decimals="2"
                                      onclick="click_input(this)" class="form-control form-control-sm text-center">
                                  </td>
                                  <td class="w-20">
                                    <input type="text" id="price{{index_}}" value="{{item.price}}"
                                      (keyup)="changeUnitPrice($event.target, index_)" numeric decimals="2"
                                      onclick="click_input(this)" class="form-control form-control-sm text-center">
                                  </td>
                                  <td class="text-center">
                                    <i class="far fa-trash-alt pointer f-s-15 text-danger" *ngIf="!item.is_principal"
                                      (click)="removeUnitPrice(index_)"></i>
                                  </td>
                                </tr>
                              </ng-container>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="form-group col-lg-12">
                  <label>Descripción del producto</label>
                  <textarea id="product_comment" formControlName="comment" class="form-control no-resize"
                    rows="2"></textarea>
                </div>
              </div>
            </div>
            <div class="col-lg-3">
              <p class="text-center p-t-15">
                <ng-container *ngIf="item.value.url_image != null">
                  <img width="200" height="165" src="tenants/{{item.value.url_image}}" alt="Preview">
                </ng-container>
                <ng-container *ngIf="item.value.url_image == null">
                  <ng-container *ngIf="imageUrl == null">
                    <img id="output" width="200" src="/images/default.png" />
                  </ng-container>
                  <ng-container *ngIf="imageUrl != null">
                    <img width="200" height="165" [src]="imageUrl" alt="Preview">
                  </ng-container>
                </ng-container>
              </p>
              <p class="text-center">
                <label for="file" style="cursor: pointer" class="m-b-0"><i class="fas fa-upload"></i>
                  Seleccionar Imagen
                  <input id="file" type="file" (change)="onFileSelected($event)" accept=".png, .jpg, .jpeg"
                    style="visibility: hidden;">
                </label>
              </p>
            </div>
            <div class="form-group col-lg-12 form__footerBtn">
              <div class="text-right">
                <a class="btn btn-secondary text-white" (click)="cancel()">Cancelar</a>
                <button type="submit" class="btn btn-primary" [disabled]="item.invalid">
                  <i class="far fa-save m-r-5"></i>
                  <ng-container *ngIf="!isEdit">
                    Guardar
                  </ng-container>
                  <ng-container *ngIf="isEdit">
                    Guardar Cambios
                  </ng-container>
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
